import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62477e35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "has-text-weight-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "has-text-weight-bold is-size-6" }
const _hoisted_6 = { class: "is-size-7" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 suggestions-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "has-text-weight-semibold" }
const _hoisted_10 = { class: "has-text-grey is-size-7" }
const _hoisted_11 = {
  key: 1,
  class: "is-flex is-align-items-center is-justify-content-center no-suggestions-container"
}

import { Address } from '@/interfaces/admin/address';
import { AddressStatus, PlaceSuggestion } from '@/interfaces/admin/places';
import { autocomplete, getPlaceDetails } from '@/controllers/global/places';
import { computed, onMounted, ref, watch } from 'vue'
import { debounce } from 'lodash';
import { postError } from '@/helpers/notification';
import i18n from '@/locales'


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedAddress',
  props: {
  address: {
    type: Object as () => Address | null,
    default: null
  },
  addressStatus: {
    type: String as () => AddressStatus | null,
    default: null
  },
  sessionToken: {
    type: String,
    required: true
  }
},
  emits: ['suggestion-selected'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit;

/**
 * Helps to smooth experience when mounting and the delay with suggestions.
 */
const hasAttemptedFetch = ref(false);
const isLocked = ref(false);
const selectedPlaceId = ref<string | null>(null);
const suggestions = ref<PlaceSuggestion[]>([]);

const fetchSuggestions = debounce(async (query: string) => {
  // Don't fetch new suggestions if we're locked (a suggestion was selected)
  if (isLocked.value) {
    return;
  }

  if (query.length <= 3) {
    suggestions.value = [];
    selectedPlaceId.value = null;
    hasAttemptedFetch.value = false;
    return;
  }
  try {
    const response = await autocomplete(query, props.sessionToken);
    suggestions.value = response.suggestions || [];
    selectedPlaceId.value = null; // Reset selection when suggestions change
  } catch (error) {
    console.error('Failed to fetch address suggestions:', error);
    postError({ text: i18n.global.t('addressState.failedToFetchSuggestions') });
    suggestions.value = [];
    selectedPlaceId.value = null;
  } finally {
    hasAttemptedFetch.value = true;
  }
}, 750);

watch(() => props.address, (newAddress) => {
  if (props.addressStatus !== AddressStatus.VERIFIED && (newAddress?.lengthWithoutCountryCode() ?? 0) > 3) {
    fetchSuggestions(newAddress?.toSingleLineString() || '');
  }
}, { deep: true });

// Clear suggestions when address is verified
watch(() => props.addressStatus, (newStatus) => {
  if (newStatus === AddressStatus.VERIFIED) {
    suggestions.value = [];
    selectedPlaceId.value = null;
    isLocked.value = false;
    hasAttemptedFetch.value = false;
  }
});

const selectSuggestion = async (suggestion: PlaceSuggestion) => {
  selectedPlaceId.value = suggestion.placeId;
  isLocked.value = true; // Lock suggestions to prevent updates

  try {
    const addressData = await getPlaceDetails(suggestion.placeId, props.sessionToken);
    emit('suggestion-selected', addressData);
  } catch (error) {
    console.error('Failed to fetch place details:', error);
    postError({ text: i18n.global.t('addressState.failedToLoadDetails') });
    selectedPlaceId.value = null;
  } finally {
    isLocked.value = false;
  }
};

const shouldShowSuggestions = computed(() => {
  const addressLength = props.address?.lengthWithoutCountryCode() ?? 0;
  return addressLength > 3 && hasAttemptedFetch.value;
});

onMounted(() => {
  if (!props.address) return

  const addressLength = props.address?.lengthWithoutCountryCode() ?? 0;
  if (props.addressStatus !== AddressStatus.VERIFIED && addressLength > 3) {
    fetchSuggestions(props.address.toSingleLineString() || '');
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "expand" }, {
    default: _withCtx(() => [
      (shouldShowSuggestions.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('addressState.unverifiedMessage')), 1),
            _hoisted_2,
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('addressState.enteredAddress')) + ": " + _toDisplayString(__props.address?.toSingleLineString()), 1),
            _hoisted_4,
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('addressState.suggested')), 1),
              _createTextVNode("   "),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('addressState.selectAddress')), 1)
            ]),
            (suggestions.value.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "mb-3",
                      key: index
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["box has-text-dark is-clickable suggestion-item", {'is-selected': selectedPlaceId.value === suggestion.placeId}]),
                        onClick: ($event: any) => (selectSuggestion(suggestion))
                      }, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(suggestion.mainText), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(suggestion.secondaryText), 1)
                      ], 10, _hoisted_8)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('addressState.noSuggestions')), 1)
                ]))
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}
}

})